export default __webpack_public_path__ + "static/image-API-extract-structured-23d216e693735eb02560e2dda2846ebc.png";